const accounts = [
    "Alice",
    "Bob",
    "Charlie",
    "Dave",
    "Eve",
    "Ferdie",
    "Alice//stash",
    "Bob//stash",
    "Charlie//stash",
    "Dave//stash",
    "Eve//stash",
    "Ferdie//stash",
]
module.exports = {
    accounts
} 